<template>
    <div class="weather-widget">
        <div class="weather-widget__icon">
            <!-- Icon component that outputs the weather icon based on the weather condition -->
            <WeatherIcon :condition="condition" />
        </div>
        <div class="weather-widget__wrapper">
            <div class="weather-widget__wrapper-inner">
                <p class="weather-widget__text">
                    Average Temperature
                </p>
                <!-- The widget dynamically shows the temperature based on the providedMonth prop
                The unit can be switched which will convert the temp to F or back to C -->
                <h2 class="weather-widget__temperature">
                    {{ temp }}°{{ unit }}
                </h2>
            </div>
            <!-- Button for unit convertion  -->
            <button
                class="weather-widget__switch"
                @click="switchUnit"
            >
                Switch to °{{ oppositeUnit }}
            </button>
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import useGlobalStore from '~/stores/GlobalStore'
import WeatherIcon from './weather-icon.vue'

const props = defineProps({
    providedMonth: {
        type: Number,
        required: true,
    },
})

const globalStore = useGlobalStore()
const { celsiusUnit } = storeToRefs(globalStore)

const kelvinTemp = ref(0)

async function fetchTemperature() {
    try {
        const data = await $fetch(`/api/weather/temperature-by-month?month=${props.providedMonth + 1}`)
        return data.temperature
    } catch (error) {
        console.error('Error fetching temperature:', error)
        return null
    }
}

kelvinTemp.value = await fetchTemperature()

const temp = computed(() => {
    if (kelvinTemp.value !== null && kelvinTemp.value !== 0) {
        if (!celsiusUnit.value) {
            return Math.round((kelvinTemp.value - 273.15) * 9 / 5 + 32)
        }

        return Math.round(kelvinTemp.value - 273.15)
    }

    return null
})

async function switchUnit() {
    celsiusUnit.value = !celsiusUnit.value
}

const unit = computed(() => celsiusUnit.value ? 'C' : 'F')
const oppositeUnit = computed(() => celsiusUnit.value ? 'F' : 'C')

const condition = computed(() => {
    if (celsiusUnit.value) {
        if (temp.value >= 25) {
            return 'sunny'
        } else if (temp.value >= 15) {
            return 'sunny_cloudy'
        } else {
            return 'cloudy'
        }
    } else {
        if (temp.value >= 77) {
            return 'sunny'
        } else if (temp.value >= 59) {
            return 'sunny_cloudy'
        } else {
            return 'cloudy'
        }
    }
})
</script>

<style lang="scss" scoped>
@use 'weather-widget';
</style>
